!function () {
    var xhr;
    var select_mark, $select_mark_filter;
    var select_model, $select_model_filter;
    var firstLoad = true;
    $select_mark_filter = $('.mark-depend[name="worksFilterMark"]').selectize({
        placeholder: "Выберите марку...",
        preload: true,
        valueField: "id",
        labelField: "name",
        searchField: ["name"],
        onChange: function (value) {
            if (!value.length) return;

            discardChangedOptions('models', $selects, selectList);

            select_model.load(function (callback) {
                xhr && xhr.abort();
                xhr = $.ajax({
                    method: "POST",
                    dataType: "JSON",
                    url: "/api/v1/models",
                    data: "mark=" + value + "&_csrf=" + $("#_csrf").val(),
                    success: function (results) {
                        select_model.enable();
                        callback(results);

                        if (results.length === 1) {
                            select_model.setValue(results[0].id);
                        } else if ($('input[name="calc[model]"]').val() > 0) {
                            select_model.setValue($('#model-id').val());
                        }
                        let fadeIn = 100;
                        let fadeOut = 100;
                        if (firstLoad) {
                            fadeIn = 0;
                            fadeOut = 0;
                            firstLoad = false;
                        }
                        setCalcBackground(value, fadeIn, fadeOut);
                    },
                    error: function () {
                        callback();
                    }
                });

            });
        }
    });
    $select_model_filter = $('.model-depend[name="worksFilterModel"]').selectize({
        placeholder: "Выберите модель...",
        valueField: "id",
        labelField: "name",
        searchField: ["name"]
    });
    if ($select_mark_filter[0] !== undefined && $select_model_filter[0] !== undefined) {
        var $selects = {
            'marks': $select_mark_filter[0].selectize,
            'models': $select_model_filter[0].selectize,
        };
        var selectList = [
            'marks',
            'models',
        ];
        if ($select_model_filter[0] !== undefined)
            select_model = $select_model_filter[0].selectize;
        if ($select_mark_filter[0] !== undefined)
            select_mark = $select_mark_filter[0].selectize;
    }
    function discardChangedOptions(currentOption, $selects, selectList = []) {
//    discard marks, models, generations, series, modifications
        let discard = false;
        selectList.forEach(function (option) {
            if (option == currentOption) {
                discard = true;
            }
            if (discard && $selects[option] != undefined) {
                $selects[option].disable();
                $selects[option].clearOptions();
            }
        })
    }
}()

$(document).ready(function (){
    currenMarkId = $('#worksFlterForm .mark-depend .item').data('value');
    $('.mark-depend[name="worksFilterMark"]')[0].selectize.trigger('change', String(currenMarkId));
})
